import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage energy-glow tech-grid py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-189" data-mp="30h7k3kxsvmsg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-190" data-mp="2vqhdy5hjvfwp">
        <div className="text-center" data-id="element-191" data-mp="2vppn17ywe6cr">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-192" data-mp="2voob71a25ftz">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-onDark" data-id="element-193" data-mp="35g0zxk0k7pvs">
            Domingo a las 11 de la noche. Mañana tienes clase de energías renovables. Y todavía estás buscando cómo
            explicar la diferencia entre almacenamiento en baterías, sistemas híbridos y microredes sin que tus alumnos
            se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-mutedDark" data-id="element-194" data-mp="1k49bzq46wy9m">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-10 rounded-xl border border-lineDark p-6 sm:p-8" data-id="element-195" data-mp="scibpgsmoa8r">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold text-white" data-id="element-196" data-mp="174ir2k3g4z49">
            <AlertTriangleIcon className="h-5 w-5 text-danger" aria-hidden="true" data-id="element-197" data-mp="1g3dy1yebed8m" />
            El costo de no tener el material correcto
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-198" data-mp="3dugvt7gr7oo8">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-199" data-mp="3htz6zbirwldv">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-danger" aria-hidden="true" data-id="element-200" data-mp="ozquw2mehftf" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-201" data-mp="y0yuqp4keopm">
          <p className="text-lg font-bold text-yellow" data-id="element-202" data-mp="y1qe91kw0vzj">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-203" data-mp="17yl8h8a4oa80">Planifica todo tu año hoy.</p>
        </div>
      </div>
    </section>;
}